/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 796
// module chunks = 0